<script lang="ts">
  import { Route } from "svelte-router-spa";
  import Spacer from "@/components/spacer.svelte";
  import product1 from "./content/product-1.svelte";
  import product2 from "./content/product-2.svelte";
  import product3 from "./content/product-3.svelte";
  import product4 from "./content/product-4.svelte";
  import consult1 from "./content/consult-1.svelte";
  import consult2 from "./content/consult-2.svelte";
  import consult3 from "./content/consult-3.svelte";
  import management1 from "./content/management-1.svelte";
  import management2 from "./content/management-2.svelte";
  import development1 from "./content/development-1.svelte";
  import development2 from "./content/development-2.svelte";
  import development3 from "./content/development-3.svelte";
  import Subnav_3depth from "./subviews/subnav-3depth.svelte";

  export let currentRoute;
  export let params;

  // 현재 메뉴 위치에 따라 내용 뷰를 동적으로 변경
  const contentViews = {
    product: [product1, product2, product3, product4],
    consult: [consult1, consult2, consult3],
    management: [management1, management2],
    development: [development1, development2, development3],
  };

  /** 현재 페이지 코드, 경로의 맨 뒷부분을 취함 */
  let pagename = "";

  /** 현재 페이지가 3차메뉴 인덱스 몇번인가 */
  let currentFourthMenuIndex = 0;

  $: {
    // 현재 url 경로에서 마지막 단어만 추출
    pagename = currentRoute.path.split("/").pop();
  }
</script>

<!-- route 패키지 사용에 필수 태그 -->
<Route {currentRoute} {params} />

<div id="wrap">
  <!-- 3차, 4차메뉴 -->
  <Subnav_3depth {currentRoute} bind:currentFourthMenuIndex />

  <Spacer size="230px" class_ext="pc" />
  <Spacer size="160px" class_ext="mobile" />

  <!-- 본문 내용 -->
  <svelte:component this={contentViews[pagename][currentFourthMenuIndex]} />
</div>

<style lang="scss">
  .w600 {
    width: 600px;
  }

  #wrap {
    color: #5c3327;

    h1 {
      font-size: 3rem;
      font-weight: 700;
      text-align: center;
    }
  }
</style>
